import { AsyncPipe, CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ThemeService } from '@services/theme.service';
import { SubscribedComponent } from 'src/app/lib/subscribed.component';
import { CustomCurrencyPipe } from 'src/app/pipes/custom-currency.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppointmentStatusInfoComponent } from '../appointment-status-info/appointment-status-info.component';
import { LocationService } from '@services/location.service';
import { Location } from 'src/app/models/location.model';
import { GiftCard } from 'src/app/models/gift-card.model';
import { GiftCardStore } from '@services/gift-card.store';
import { watchEntity } from 'src/app/lib/entity-watcher.util';
import { LocationScheduleComponent } from '../location-schedule/location-schedule.component';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'app-gift-card-content',
  templateUrl: './gift-card-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AsyncPipe,
    NzIconModule,
    NzTypographyComponent,
    NzButtonModule,
    CustomCurrencyPipe,
    TranslateModule,
    AppointmentStatusInfoComponent,
    LocationScheduleComponent,
    EmptyStateComponent,
  ],
})
export class GiftCardContentComponent extends SubscribedComponent implements OnInit {
  @Input() isModal = false;
  @Output() closeRequested = new EventEmitter<void>();
  location?: Location;
  giftCard: GiftCard | null = null;
  continueBtnLabel = '';
  showContinueButton = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private locationService: LocationService,
    public themeService: ThemeService,
    private translate: TranslateService,
    private giftCardStore: GiftCardStore,
  ) {
    super();
  }

  ngOnInit() {
    this.location = this.locationService.getLocation();
    this.watchEntities();
  }

  watchEntities() {
    watchEntity(this.locationService.locationChanged, this.destroyed$, (location) => {
      this.location = location;
      this.cdRef.markForCheck();
    });
    watchEntity(this.giftCardStore.watchGiftCard(), this.destroyed$, (giftCard) => {
      this.giftCard = giftCard;
      this.cdRef.markForCheck();
    });
    watchEntity(this.themeService.getCartBtnVisibility(), this.destroyed$, (isVisible) => {
      this.showContinueButton = isVisible;
      this.cdRef.markForCheck();
    });
    watchEntity(this.themeService.getCartBtnLabel(), this.destroyed$, (label) => {
      this.continueBtnLabel = label;
      this.cdRef.markForCheck();
    });
  }

  get validityLabel(): string {
    const expiryDays = this.location?.giftCardsConfig?.expiryDays;

    if (!expiryDays) {
      return '';
    }

    return this.translate.instant('components.gift-card-content.label-valid-months', {
      count: Math.round(expiryDays / 30),
    });
  }

  onContinue() {
    this.themeService.setFormSubmitAction(true);

    if (this.isModal) {
      this.closeRequested.emit();
    }
  }
}
